import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { BlogLayout } from "@/pages/blog/BlogLayout";

const API = process.env.REACT_APP_BACKEND_URL;
const TEXT = {
  conferma: { ok: ["Iscrizione confermata.", "Grazie! Riceverai qualche volta all'anno consigli semplici per gengive e denti sani."] },
  disiscrizione: { ok: ["Iscrizione annullata.", "Non riceverai più la newsletter. Se cambi idea, puoi iscriverti di nuovo dal sito quando vuoi."] },
};

export default function NewsletterPage() {
  const { action, token } = useParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    if (!TEXT[action]) { setState("error"); return; }
    axios.post(`${API}/api/newsletter/${action}/${token}`).then(() => setState("ok")).catch(() => setState("error"));
  }, [action, token]);
  const [title, text] = state === "ok" ? TEXT[action].ok : ["Link non valido.", "Il link potrebbe essere scaduto. Scrivici su WhatsApp se hai bisogno."];
  return (
    <BlogLayout>
      <section className="max-w-3xl mx-auto px-6 pt-44 pb-32 min-h-[60vh]" data-testid="newsletter-page">
        {state === "loading" ? <Loader2 className="animate-spin text-[#3E6B48]" /> : (
          <>
            <p className="eyebrow text-[#3E6B48]">Newsletter</p>
            <h1 className="f-serif text-5xl sm:text-6xl text-[#1B3B28] mt-5 leading-tight" data-testid="newsletter-result">{title}</h1>
            <p className="text-lg text-[#526356] mt-6">{text}</p>
            <Link to="/blog" className="mt-10 inline-block rounded-full bg-[#1B3B28] text-[#FCFBF7] px-6 py-3.5 text-sm" data-testid="newsletter-blog-link">Leggi il blog</Link>
          </>
        )}
      </section>
    </BlogLayout>
  );
}
